import React from 'react'

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            About SnapTools
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional image and document processing tools built for the modern web.
          </p>
        </div>
        
        <div className="card">
          <div className="py-12">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Our Mission
            </h3>
            <p className="text-gray-600 mb-6">
              SnapTools provides professional-grade image and document processing capabilities 
              directly in your browser. Built on Cloudflare's global edge network, we deliver 
              fast, secure, and reliable tools for everyone.
            </p>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              Key Features
            </h3>
            <ul className="text-gray-600 space-y-2">
              <li>• Lightning-fast processing powered by Cloudflare Workers</li>
              <li>• Secure processing with automatic file deletion</li>
              <li>• No software installation required</li>
              <li>• Works on all devices and browsers</li>
              <li>• Professional-quality results</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
